import {  IconButton as ButtonIcon} from '@mui/material'
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import {FormikErrors} from 'formik'
import React from 'react';

import API, { glass, iOrderDetail, unit_type } from '../../services/api/api';
import { AxiosError } from 'axios';
import { iGlassWorks, orderState, tGlassworksValue } from './OrderSlice';




 export  const  checkIfTotallyFilled=(values: Object) => {
        let totally_filled = true;
        let unwanted_keys = ['single_price','total_price','serial_number','raw_price','area']
 
        Object.entries(values).map(([key,v],i) => {
          if (!Boolean(v) && !unwanted_keys.includes( key) ) {
            totally_filled = false;
            return;
          }
        });
        return totally_filled;
      }


export const  checkIfClientExisted= (value:string,client_list:any[])
:null|{client_id:number,client_name:string}=>{

        let client=null
           client=client_list.filter(ele=> ele.serial_no === value)[0]

        return client
       } 


export   const enterButton = (fun:Function)=> 
React.createElement(ButtonIcon,{
  style:{ background: 'var(--primary-color)' }
,onClick:()=>fun(),sx:{sm:{width:'20px',height:'20px'}}
},
React.createElement(AssignmentReturnedIcon ,{style:{ color: 'white' }
,sx:{sm:{width:'20px',height:'20px'}}})
)
// <ButtonIcon
// style={{ background: 'var(--primary-color)' }}
// onClick={()=>fun()}>
// <AssignmentReturnedIcon style={{ color: 'white' }} 
// sx={{sm:{width:'20px',height:'20px'}}}/>
// </ButtonIcon>       


export const checke_GlassWork_existing= (glass_id:number, glass_works:iGlassWorks):null|tGlassworksValue[]=>{

  let existed_glass_id:null|tGlassworksValue[]=null
  let arr_glassworks = Object.values(glass_works)
  arr_glassworks.map(arr=>{
      let has_glass_id= arr.filter(ele=>ele.value.toString() === glass_id.toString())

      if (has_glass_id.length>0) {
        existed_glass_id=has_glass_id
      }
  })
  return existed_glass_id
}

export const checke_GlassWork_existing_v2= (glass_id:number, glass_works:iGlassWorks, index:number):null|tGlassworksValue[]=>{

  let existed_glass_id:null|tGlassworksValue[]=null
existed_glass_id=glass_works[index].filter(ele=>ele.value.toString() === glass_id.toString()).length>0 ? 
glass_works[index]: null
  return existed_glass_id
}


/*will take state.glass_works and check if the glassworks related to passed galss_id are not existed
if not , it will fetch it and pass it to dispatch , or it will use what was fetched before
TODO: you can split it to fun to check existence and and fetch function , it will be better */
export const fetchGlassWorkData =  async(
  glass_id: number,
   index: number ,
  ENDPOINTS:API,
  setIsFetching:Function , 

): Promise<{data:(tGlassworksValue[])|null,index:number}>=> {

   setIsFetching(true)
    let response = ENDPOINTS.pricing()
      .selectByGlasses({ glass_id  ,page:1,page_size:100,sort_field:35,sort_direction:'ASC'})
      .then((res) => {
        setIsFetching(false)
       
        if (res.data.data) {
          let data:tGlassworksValue[] =
             res.data.data.map((ele) => ({
              ...ele,
              value: ele.gwid??-1,
              name: ele.gwname??''
            })
          ).filter((ele: any) => ele.is_priced);
   
           
          return { index, data }
        }
        return { index:-1, data:null }
      })
      .catch((err: AxiosError) => {
        setIsFetching(false)
        return { index:-1, data:null }
      })
    return response
  
}


export const checkRequestNotRepeated=(glass_dis_fetched:{[key:number]:number}
                                      ,index:number
                                      ,glass_id:number):boolean=>{

    let request_has_made=false                                    
    if( glass_dis_fetched[index]=== glass_id) request_has_made=true

    return request_has_made
}

export const checkRequestNotRepeated_v2=(glass_dis_fetched:{[key:number]:number}
                                    
                                      ,glass_id:number):boolean=>{

    let request_has_made=false                                    
    request_has_made = Object.values(glass_dis_fetched).includes(glass_id)

    //if( glass_dis_fetched.current[index]=== glass_id) request_has_made=true

    return request_has_made
}

export const get_index=(glass_dis_fetched:{[key:number]:number}
                                     
                                      ,glass_id:number):number=>{
    let found_index = -1 
    let inede_keys = Object.keys(glass_dis_fetched).map(ele=>parseInt(ele)) 
     for (let  i of inede_keys) {
        if (glass_dis_fetched[i]=== glass_id){
            found_index = i
            break ;
        }                                 
      }
    return found_index
}

export const  setTouchedAll =(setTocuhed:Function,errors:any)=>{
  let touched:{[key:string]:boolean|{[key:string]:boolean}[]|undefined[]|{[key:string]:boolean}}={}
  Object.keys(errors).map(ele=>{
     if (typeof(errors[ele]) === "object") {
      if (Array.isArray(errors[ele])){
        let err_array =errors[ele] as Array<{[key:string]:string|undefined}>
          let touched_array:{[key:string]:boolean}[]|undefined[]=Array(err_array.length).fill('undefined')

        err_array.map((obj_err,index)=>{
        if (obj_err){
          let obj:{[key:string]:boolean}={}
           let [key,value]=Object.entries(obj_err)[0]
            if (key)obj[key]=true
           if (value) touched_array[index]=(obj)
           }
        })
       touched[ele]=touched_array
      }
      else {
        
          let err_obj :{[key:string]:boolean}={}
          Object.keys(errors[ele]).map((key)=>{
            if (errors[ele][key]){
              err_obj[key]=true
              
            }
          })
          touched[ele]=err_obj

          
      }
       
     }

     else {
      touched[ele]=true
     }
     

  }
  )
  setTocuhed(touched)
}



export const handleKeyDown = (event: React.KeyboardEvent) => {
  if (event.key === 'Tab') {
    event.preventDefault(); // Prevent the default Tab behavior

    // Invert the focus direction
    const focusableElements = document.querySelectorAll('.tab_element_inputTable');
    const focusableArray = Array.from(focusableElements);

    const currentIndex = focusableArray.indexOf(document.activeElement!!);
    const nextIndex =
      currentIndex === 0 && focusableArray ? focusableArray?.length - 1 : currentIndex - 1;
     
      if (focusableArray[nextIndex].tagName === 'INPUT' ){

        (focusableArray[nextIndex] as HTMLInputElement).focus();
      }
      if (focusableArray[nextIndex].tagName === 'SELECT' ){
        (focusableArray[nextIndex] as HTMLInputElement).focus();
        (focusableArray[nextIndex] as HTMLSelectElement).click();
      }
  }
};



export type formik_error_value=  string | string[] | FormikErrors <any>  | FormikErrors <any>[] | undefined


export interface iRow {
  glass_work_id?: number;
  glasswork_code?: string;
  piece_code?: string;
  length?: number;
  width?: number;
  piece_count?: number;
  glass_id?: number;
  glass_code?: string;
  serial_number?: number;
  raw_price?:number, 
  single_price?:number, 
  total_price?:number,
  glass_work?:iGlassWorks,
  glass?:glass

}

export type price_related_keys ='width' | 'length' | 'piece_count'


interface params {price?:number,width?:number,length?:number,piece_count?:number,min_area?:number}

 export const calculate_total_price = (single_price:number , piece_count:number)=> parseFloat((single_price*piece_count).toFixed(2))


export  const calculate_single_price = (params:params)=>{
  let {price,min_area,width,length,piece_count}=params
  if (!price || typeof(min_area) =='undefined' || !length || !width || !piece_count) return 
    if (price > -1 && min_area >-1 ){
    let area =( parseFloat(length.toString()) * parseFloat(width.toString()))/10000
    let target_area = area > min_area ? area : min_area
    return calculate_total_price(parseFloat((price * target_area)?.toFixed(2)),piece_count)
  }
  return undefined
  }

export const calculate_single_price_perimeter=(params:params)=> {
 
  let {price,min_area,width,length,piece_count}=params
 
  if (!price || typeof(min_area) =='undefined' || !length || !width || !piece_count) return 
   if (price > -1 && min_area > -1) {
    let perimeter = ((parseFloat(length.toString())+ parseFloat(width.toString())) *2 )/100
    let target_perimeter = perimeter > min_area ? perimeter : min_area 

    return calculate_total_price((target_perimeter * price),piece_count)
   }
}

export const calculate_single_price_piece=(params:params)=> {
  let {price,min_area,piece_count}=params
  if (!price || typeof(min_area) =='undefined'  || !piece_count) return 
   if (price > -1 && min_area > -1) {

    let target_pieces = parseFloat(piece_count.toString()) > min_area ? parseFloat(piece_count.toString()) : min_area 
    let total = target_pieces * price
   
    return total
   }
}

 
  
  let calculations_ = {
    'Piece':calculate_single_price_piece,
    'Length':calculate_single_price_perimeter,
    'Area':calculate_single_price
  }

  export const total_price_calculator= (width:number,length:number,piece_count:number,price:number,min_area:number,unit:unit_type)=>{
      
       let params:params= {width,length,piece_count,price,min_area}
       let single_price_calculator =calculations_[unit]
       let total_price= single_price_calculator(params)
     
       return total_price
       
  }

  export const area_calculator=(unit:unit_type,width?:number,length?:number,piece_count?:number) =>{
    if (unit == 'Area') return (parseInt(width?.toString()??'0')* (parseInt(length?.toString()??'0')) )/10000
    if (unit=='Length') return ((((parseInt(width?.toString()??'0'))+(parseInt(length?.toString()??'0')))*2)/100)
     return piece_count??0
    }
  
   
      const fetchRawPrice = (glass_id: number, glass_work_id: number,state:orderState): {raw_price:number,min_area:number,unit:unit_type} => {
        let list_glasses = Object.values(state.fetched_glassworks)
        if (list_glasses.length === 0) {
    
          return {raw_price:-1,min_area: -1,unit:'Area'}
        }
        let selected_glasswork: undefined | tGlassworksValue = undefined
        list_glasses.filter(ele => {
          if (ele[0].gid?.toPrecision() === glass_id.toString()) {
            selected_glasswork = ele.filter(elem => elem.gwid?.toString() === glass_work_id.toString())[0]
          }
        }
        )
    
        if (selected_glasswork === undefined) {
    
          return {raw_price:-1,min_area: -1,unit:'Area'}
        }
    
        return {raw_price:selected_glasswork['price'] ?? 0, min_area:selected_glasswork['min_area'],unit:selected_glasswork['unit']}
    
    
      }
    
   export  const handlePrices = (values:iOrderDetail,state:orderState)=>{
          //console.log('state from handlePrices',state)
           let glass_id =undefined
           let glass_work_id=undefined
           let width= undefined
           let length=undefined
           let price=values['price'] ? values['price'] : undefined
           let single_price=undefined
           let total_price =undefined
           let min_area = -1
           let piece_count = undefined
           let raw_price = -1
           let unit:unit_type= 'Area'
           
           if ('glass_id' in values) glass_id=values['glass_id']
           if ('glass_work_id' in  values) glass_work_id = values['glass_work_id']
           if ('width' in values) width = values['width']
           if ('length' in values) length=values['length']
           if ('piece_count' in values) piece_count = values['piece_count']
          
           if (glass_id && glass_work_id){ 
            let glass_work_features=fetchRawPrice(glass_id,glass_work_id,state)
            raw_price=glass_work_features.raw_price
            min_area=glass_work_features.min_area
            unit=glass_work_features.unit
          }
          //  if (width && length) single_price=calculate_single_price(price && price > -1 ? price : raw_price,width,length,min_area)
          //  if (single_price &&piece_count ) total_price = calculate_total_price(single_price,piece_count) 
           
          if (width&&length&&piece_count&&unit) total_price= total_price_calculator(width
                                                                                ,length
                                                                                ,piece_count,price&& price > -1 ? price : raw_price
                                                                                ,min_area,unit)
           let area = area_calculator(unit,width,length,piece_count)
           //console.log('returning from handle Prices',glass_work_id)
           return [single_price,total_price,price && price > -1 ? price : raw_price,raw_price ,min_area >area? min_area:area]  
           
          }